import AdminRouter from "@/@admin/router";
import { $api, RouterUtilClass } from "@/shared";
import { Business, User } from "@/shared/interfaces";
import { ApiResourceResult } from "@/shared/vuex";
import { StoreOptions } from "vuex";

export interface AdminBiddingsVuexState extends ApiResourceResult<User> {
  biddings?: Business[];
  loading: boolean;
}

export const AdminBiddingsVuex: StoreOptions<AdminBiddingsVuexState> = {
  ...{ namespaced: true },
  state: {
    biddings: undefined,
    loading: false,
  },
  mutations: {},
  actions: {
    /**
     * Fetches users
     * @param context
     */
    fetch(context) {
      context.state.loading = true;
      $api.admin
        .get<ApiResourceResult<Business>>(
          `/v1/biddings?${RouterUtilClass.extractQuery(AdminRouter)}`
        )
        .then(({data}) => {
          context.state.count = data.count;
          context.state.next = data.next;
          context.state.skipped = data.skipped;
          context.state.biddings = data.resources;
          //   Vue.set
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
  },
  modules: {},
  //
  getters: {},
};
